import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "sidebar-title-wrapper",
  "data-testing": "sidebar-wrapper"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RightSidebarTitle',
  props: {
  title: {
    required: true,
    type: String
  },
  fontSize: {
    required: false,
    type: Number,
    default: 14
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", {
      class: "sidebar-title",
      style: _normalizeStyle({ fontSize: `${__props.fontSize}px` })
    }, _toDisplayString(__props.title), 5),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})